// extracted by mini-css-extract-plugin
module.exports = {"Accordion":"Accordion__2S5BO","Accordion_heading":"Accordion_heading__2S5BO"};